import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_gtm_f53b3b0e from 'nuxt_plugin_gtm_f53b3b0e' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_gtag_2659d9e2 from 'nuxt_plugin_gtag_2659d9e2' // Source: ./gtag.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_44c6b88b from 'nuxt_plugin_cookieuniversalnuxt_44c6b88b' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_5d9c71b8 from 'nuxt_plugin_pluginutils_5d9c71b8' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_1e477103 from 'nuxt_plugin_pluginrouting_1e477103' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_c3005d68 from 'nuxt_plugin_pluginmain_c3005d68' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_veevalidate_5677dbf0 from 'nuxt_plugin_veevalidate_5677dbf0' // Source: ./vee-validate.js (mode: 'all')
import nuxt_plugin_moment_372ba1d6 from 'nuxt_plugin_moment_372ba1d6' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_axios_17693ee3 from 'nuxt_plugin_axios_17693ee3' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_buefy_4d6f8398 from 'nuxt_plugin_buefy_4d6f8398' // Source: ./buefy.js (mode: 'all')
import nuxt_plugin_googleanalytics_ed5e053a from 'nuxt_plugin_googleanalytics_ed5e053a' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_axios_84a7d84a from 'nuxt_plugin_axios_84a7d84a' // Source: ../node_modules/marketplace-front-core/plugins/axios (mode: 'all')
import nuxt_plugin_inject_04f08ecc from 'nuxt_plugin_inject_04f08ecc' // Source: ../node_modules/marketplace-front-core/plugins/inject (mode: 'all')
import nuxt_plugin_lang_6756ec2e from 'nuxt_plugin_lang_6756ec2e' // Source: ../node_modules/marketplace-front-core/plugins/lang (mode: 'all')
import nuxt_plugin_validators_6db02f1c from 'nuxt_plugin_validators_6db02f1c' // Source: ../node_modules/marketplace-front-core/plugins/validators (mode: 'all')
import nuxt_plugin_directives_7da9d1bf from 'nuxt_plugin_directives_7da9d1bf' // Source: ../node_modules/marketplace-front-core/plugins/directives (mode: 'all')
import nuxt_plugin_global_016ce8de from 'nuxt_plugin_global_016ce8de' // Source: ../node_modules/marketplace-front-core/plugins/global (mode: 'all')
import nuxt_plugin_gtag_675aec64 from 'nuxt_plugin_gtag_675aec64' // Source: ../node_modules/marketplace-front-core/plugins/gtag (mode: 'all')
import nuxt_plugin_coreWebVitals_22a2ffe1 from 'nuxt_plugin_coreWebVitals_22a2ffe1' // Source: ../node_modules/marketplace-front-core/plugins/coreWebVitals (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"Schuette® %s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"google-site-verification","content":"1yYHjG1PqliM6aQoZZ1J0W7r7sDWtAtTNkgNSj8A49I"},{"name":"google-site-verification","content":"6-VnH6WislvxR1-g70PJhs9CKy7nYSNCnjon9Q4rDqw"},{"name":"google-site-verification","content":"7xSmTgBX6DweGZ3MvmqjbkK4CNeq89BsVmfW9e30Z1g"},{"name":"facebook-domain-verification","content":"b9jvu1gkzegk70obbi0l3dwboyalhm"},{"name":"facebook-domain-verification","content":"5adb9vegx3ch0s5cp6wwiwdg6zm0ni"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-666487120","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-T9J44VZ4')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"noscript":[{"innerHTML":"\u003Cstyle\u003E.no-js-hide{display:none !important;}.no-js-show{display:block !important;}\u003C\u002Fstyle\u003E"},{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-T9J44VZ4&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizers":["noscript"],"style":[],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_gtm_f53b3b0e === 'function') {
    await nuxt_plugin_gtm_f53b3b0e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_2659d9e2 === 'function') {
    await nuxt_plugin_gtag_2659d9e2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_44c6b88b === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_44c6b88b(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_5d9c71b8 === 'function') {
    await nuxt_plugin_pluginutils_5d9c71b8(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_1e477103 === 'function') {
    await nuxt_plugin_pluginrouting_1e477103(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_c3005d68 === 'function') {
    await nuxt_plugin_pluginmain_c3005d68(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_5677dbf0 === 'function') {
    await nuxt_plugin_veevalidate_5677dbf0(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_372ba1d6 === 'function') {
    await nuxt_plugin_moment_372ba1d6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_17693ee3 === 'function') {
    await nuxt_plugin_axios_17693ee3(app.context, inject)
  }

  if (typeof nuxt_plugin_buefy_4d6f8398 === 'function') {
    await nuxt_plugin_buefy_4d6f8398(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_ed5e053a === 'function') {
    await nuxt_plugin_googleanalytics_ed5e053a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_84a7d84a === 'function') {
    await nuxt_plugin_axios_84a7d84a(app.context, inject)
  }

  if (typeof nuxt_plugin_inject_04f08ecc === 'function') {
    await nuxt_plugin_inject_04f08ecc(app.context, inject)
  }

  if (typeof nuxt_plugin_lang_6756ec2e === 'function') {
    await nuxt_plugin_lang_6756ec2e(app.context, inject)
  }

  if (typeof nuxt_plugin_validators_6db02f1c === 'function') {
    await nuxt_plugin_validators_6db02f1c(app.context, inject)
  }

  if (typeof nuxt_plugin_directives_7da9d1bf === 'function') {
    await nuxt_plugin_directives_7da9d1bf(app.context, inject)
  }

  if (typeof nuxt_plugin_global_016ce8de === 'function') {
    await nuxt_plugin_global_016ce8de(app.context, inject)
  }

  if (typeof nuxt_plugin_gtag_675aec64 === 'function') {
    await nuxt_plugin_gtag_675aec64(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_coreWebVitals_22a2ffe1 === 'function') {
    await nuxt_plugin_coreWebVitals_22a2ffe1(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
